import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { IGenericJSON } from '../helpers/interface';
import { Observable, map } from 'rxjs';
import { Interest } from '../models/interest';

@Injectable({
  providedIn: 'root',
})
export class InterestService {
  private http: HttpClient = inject(HttpClient);

  constructor() {}

  /**
   * Fetches all available interests from the API and maps them to Interest models.
   * @returns {Observable<Interest[]>}
   */
  getInterests(): Observable<Interest[]> {
    return this.http
      .get<IGenericJSON[]>(`/api/interests`)
      .pipe(map((data) => Interest.digestResponse(data)));
  }

  /**
   * Fetches the currently authenticated student's selected interests.
   * @returns {Observable<Interest[]>}
   */
  getStudentInterests(): Observable<Interest[]> {
    return this.http
      .get<IGenericJSON[]>(`/api/interests/student`)
      .pipe(map((data) => Interest.digestResponse(data)));
  }

  /**
   * Creates a new interest entry.
   * @param {any} interest - The interest payload to send to the API.
   * @returns {Observable<Interest>}
   */
  studentInterests(interests: Interest[]): Observable<Interest[]> {
    return this.http
      .post<IGenericJSON[]>('api/interests', interests)
      .pipe(map((data) => Interest.digestResponse(data)));
  }
}
